import { render } from "./bookSettings.vue?vue&type=template&id=14834870&scoped=true"
import script from "./bookSettings.vue?vue&type=script&lang=js"
export * from "./bookSettings.vue?vue&type=script&lang=js"

import "./bookSettings.vue?vue&type=style&index=0&id=14834870&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14834870"]])

export default __exports__